import * as z from 'zod';
import * as ba from './base';
import { assertVueComponent } from '../helpers';

export interface ReloadSlickgridActionArgs {
  grid: string | string[];
}

export class ReloadSlickgridAction extends ba.Action<
  ReloadSlickgridActionArgs,
  any
> {
  static get manifest() {
    return {
      name: 'reloadSlickgrid',
      schema: z.object({
        grid: z.union([z.string(), z.array(z.string())]),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: ReloadSlickgridActionArgs) {
    assertVueComponent(event.component);

    const app = (event.component as any).$app;
    if (app && app.events) {
      app.events.emit('slickgrid:reload', args);
    }
  }
}
